import { Injectable } from '@angular/core';
import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class ImageRotationStorageService {
  private readonly storagePrefix = 'shared-image-rotation';

  constructor(private localStorageService: LocalStorageService) {
  }

  getRotation(examParseId: unknown): number {
    if (!examParseId) {
      return 0;
    }
    const rotation = this.localStorageService.getItem(this.getStorageKey(examParseId));
    return this.normalizeRotation(rotation);
  }

  setRotation(examParseId: unknown, rotation: number): void {
    if (!examParseId) {
      return;
    }
    const normalizedRotation = this.normalizeRotation(rotation);
    if (normalizedRotation === 0) {
      this.resetRotation(examParseId);
      return;
    }
    this.localStorageService.setItem(this.getStorageKey(examParseId), normalizedRotation);
  }

  resetRotation(examParseId: unknown): void {
    if (!examParseId) {
      return;
    }
    this.localStorageService.removeItem(this.getStorageKey(examParseId));
  }

  getTransform(examParseId: unknown): string {
    return `rotate(${this.getRotation(examParseId)}deg)`;
  }

  private getStorageKey(examParseId: unknown): string {
    return `${this.storagePrefix}:exam-parse:${encodeURIComponent(String(examParseId))}`;
  }

  private normalizeRotation(rotation: any): number {
    const parsedRotation = Number(rotation);
    if (!Number.isFinite(parsedRotation)) {
      return 0;
    }
    return ((parsedRotation % 360) + 360) % 360;
  }

}
